import { render } from "./WjGauges.vue?vue&type=template&id=abdbb08e"
import script from "./WjGauges.vue?vue&type=script&lang=js"
export * from "./WjGauges.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildagent/work/4109ecccb628e132/monorepo_migration/wijmo-sample/reference-samples/config/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__